import { FrontendConfigurationTypes } from '../types';

export const formatCalculatedParameters = (calculatedParameters: FrontendConfigurationTypes) =>
  Object.keys(calculatedParameters).reduce((acc, el) => {
    if (typeof calculatedParameters[el] === 'boolean') {
      acc[el] = Boolean(calculatedParameters[el]);
      return acc;
    }
    if (typeof calculatedParameters[el] === 'number') {
      acc[el] = Number(calculatedParameters[el]);
      return acc;
    }

    if (
      typeof calculatedParameters[el] === 'string' &&
      ['true', 'false'].includes(String(calculatedParameters[el]))
    ) {
      acc[el] = calculatedParameters[el] === 'true';
      return acc;
    }

    if (typeof calculatedParameters[el] === 'string' && Number(calculatedParameters[el])) {
      acc[el] = Number(calculatedParameters[el]);
      return acc;
    }

    if (typeof calculatedParameters[el] === 'string') {
      acc[el] = String(calculatedParameters[el]);
      return acc;
    }
    return acc;
  }, {} as FrontendConfigurationTypes);
